
import Hero from './components/Hero';
import BrandIntro from './components/BrandIntro';
import Categories from './components/Categories';
import Programs from './components/Programs';
import ScienceProof from './components/ScienceProof';
import Facilities from './components/Facilities';
import QuickView from './components/QuickView';
import Location from './components/Location';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <BrandIntro />
      <Categories />
      <Programs />
      <ScienceProof />
      <Facilities />
      <QuickView />
      <Location />
      <Footer />
    </div>
  );
}
